import React, { useEffect, useState } from "react";

// Counter Component
const Counter = ({ finalCount, label, unit }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const duration = 2000; // Total duration of the count
    const incrementTime = 90; // Time between each increment
    const totalSteps = duration / incrementTime;
    const increment = Math.ceil(finalCount / totalSteps);

    const interval = setInterval(() => {
      setCount((prevCount) => {
        if (prevCount + increment >= finalCount) {
          clearInterval(interval);
          return finalCount;
        }
        return prevCount + increment;
      });
    }, incrementTime);

    return () => clearInterval(interval); // Cleanup on unmount
  }, [finalCount]);

  return (
    <div style={styles.counterContainer}>
      <div style={styles.count}>
        <span style={{ color: "green", fontSize: "2rem" }}>
          {count.toLocaleString()} {unit ?? ""}
        </span>
        <span style={{ fontSize: "1.2rem" }}>{label}</span>
      </div>
    </div>
  );
};

// Main Component
const RecoverySection = ({
  counters,
  title,
}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Group counters into pairs for desktop view
  const groupedCounters = [];
  for (let i = 0; i < counters.length; i += 2) {
    groupedCounters.push(counters.slice(i, i + 2));
  }

  return (
    <div style={styles.container}>
      <div style={styles.leftSide}>
        <h2 style={styles.header}>{title}</h2>
        {isMobile ? (
          counters.map((counter, index) => (
            <Counter
              key={index}
              finalCount={counter.finalCount}
              unit={counter.unit}
              label={counter.label}
            />
          ))
        ) : (
          groupedCounters.map((pair, index) => (
            <div style={styles.counterRow} key={index}>
              {pair.map((counter, idx) => (
                <Counter
                  key={idx}
                  finalCount={counter.finalCount}
                  unit={counter.unit}
                  label={counter.label}
                />
              ))}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

// Styles
const styles = {
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px",
    backgroundColor: "#f8f8f8",
  },
  leftSide: {
    flex: 1,
    padding: "20px",
    textAlign: "left",
  },
  rightSide: {
    flex: 1,
    padding: "10px",
    position: "relative",
  },
  header: {
    fontSize: "34px",
    fontWeight:"700",
    color: "#008041",
  },
  counterRow: {
    display: "flex",
    justifyContent: "space-between",
    margin: "10px 0", // Add some margin between rows
  },
  counterContainer: {
    flex: 1, // Allow counters to take equal space
    margin: "0 10px", // Add some margin between counters
  },
  count: {
    fontSize: "30px",
    fontWeight: "bold",
  },
  label: {
    fontSize: "15px",
    color: "#333",
  },
  imageContainer: {
    position: "relative",
    height: "50vh",
    width: "100%",
    borderRadius: "10px",
    overflow: "hidden",
  },
  backgroundImage: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    opacity: 0.7,
    zIndex: 1,
  },
  content: {
    position: "relative",
    zIndex: 2,
    color: "white",
    textAlign: "center",
  },
  logo: {
    position: "absolute",
    top: "20px",
    left: "20px",
    width: "80px",
    height: "80px",
  },
};

export default RecoverySection;